<template>
  <v-app>
    <PluginConfirmDialog />
    <v-main>
      <PluginAlert />
      <PluginLoading />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import PluginConfirmDialog from '@/components/plugin/PluginConfirmDialog'
import PluginAlert from '@/components/plugin/PluginAlert'
import PluginLoading from '@/components/plugin/PluginLoading'

export default {
  components: {
    PluginConfirmDialog,
    PluginAlert,
    PluginLoading
  }
}
</script>
